<template>
    <section class="app-main">
        <el-card class="table-margin">
            <el-table :data="tableData"  height="600">
                <el-table-column prop="title" label="订单号" align="center"></el-table-column>
                <el-table-column prop="delivery_method_title" label="收货方式"  align="center" ></el-table-column>
                <el-table-column prop="shops_title" label="所属商家"  align="center" ></el-table-column>
                <el-table-column prop="phone" label="下单账号"  align="center"  show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span  v-if="scope.row.phone != ''">{{scope.row.phone}}</span>
                        <span  v-else>{{scope.row.email}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" plain size="mini"  @click="goDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background layout="prev, pager, next" :total="total" :page-size="10" style="margin-top:20px"
            @current-change="changePage"></el-pagination>
        </el-card>
    </section>
</template>



<script>


import { pack_list } from "@/api/warehouse.js"
export default {
    data() {
        return {
            tableData:[],
            disabled: false,
            total: 0,
            page: 1
        }
    },
    methods: {
        changePage(e) {
            this.page = e
            this.getData()
        },
        getData(){
            pack_list({page: this.page}).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total = res.data.total
                }
            })
        },
        // 查看详情
        goDetail(row) {
            this.$router.push( {path: `/warehouse/out/packdetail/${row.id}`} )
        },
       
    },

    created(){
        this.getData()
    },
    activated() {
        this.getData()
    },
    watch: {
        '$route' () {
            this.getData();
        }
    },
}
</script>
<style lang="less" scoped>
section {
  .table-margin {
      margin-top: 30px;
  }
}
</style>